import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundAntiClockwise32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowRoundAntiClockwise32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.277 14c1.093-3.695 4.77-5.766 8.52-4.761 3.813 1.021 5.972 4.76 4.95 8.573s-4.76 5.971-8.573 4.95a7.3 7.3 0 0 1-2.806-1.433 6 6 0 0 1-.653-.63 4 4 0 0 1-.175-.215l-.003-.005a1 1 0 0 0-1.647 1.135l.825-.565c-.825.565-.825.566-.824.566l.001.002.003.004.007.01.02.027q.022.033.063.085.08.107.228.276c.197.224.487.523.876.847a9.3 9.3 0 0 0 3.567 1.828C18.536 26 23.371 23.21 24.68 18.33s-1.484-9.715-6.364-11.023c-4.237-1.135-8.439.819-10.33 4.546V9.5a1 1 0 0 0-2 0V16h6.5a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundAntiClockwise32);
